export default __webpack_public_path__ + "static/media/home-split-portfolio-img-06.ced7e8d7.jpg";